import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import { IconBellExclamation } from "@tabler/icons-react";

import SkeletonText from "../../../SkeletonText";
import useCountersStore from "../../../../store/counts";
import useContactsStore from "../../../../store/contacts";
type MessagesStatsProps = {
  isLoading?: boolean;
};

export default function MessagesStats({ isLoading }: MessagesStatsProps) {
  const history = useHistory();
  const { filters, setFilters } = useContactsStore((state) => ({
    filters: state.filters,
    setFilters: state.setFilters,
  }));
  const counters = useCountersStore((state) => ({
    review: state.escalated,
    manual: state.manualUnread,
    total: state.total,
    loading: state.loading,
  }));
  const { review, manual, total, loading } = counters;

  const isRequesting = isLoading || loading;

  const onBeforeNavigate = () => {
    const updated = filters.map((item) =>
      item.type === "bucket"
        ? { ...item, isActive: true, value: "pending" }
        : item
    );
    setFilters(updated);
    history.push("/chats?bucket=pending");
  };

  return (
    <>
      {isRequesting ? (
        <SkeletonText rows={6} />
      ) : (
        <div className="row mt-3">
          {total > 0 ? (
            <div className="col-md-12">
              <div className="visito-card position-relative rounded-3 h-100">
                <div className="visito-card-body d-flex gap-3">
                  <div className="flex-grow-1">
                    <h6 className="fs-6">
                      <FormattedMessage id="home.requiresAction" />
                      {": "}
                      <span className="fw-bold color-visito-1">
                        {Intl.NumberFormat("en-US").format(total)}
                      </span>
                    </h6>

                    <ul className="list-unstyled small my-3 fs-4">
                      {review > 0 && (
                        <li className="mb-2 color-step-700">
                          <span className="badge rounded-pill text-bg-warning me-2 total-badge">
                            {review}
                          </span>
                          <FormattedMessage id="home.messagesUnderReview" />
                        </li>
                      )}
                      {manual > 0 && (
                        <li className="mb-2 color-step-700">
                          <span className="badge rounded-pill text-bg-info me-2 total-badge">
                            {manual}
                          </span>
                          <FormattedMessage id="home.unreadManualMessages" />
                        </li>
                      )}
                    </ul>
                    <button
                      onClick={onBeforeNavigate}
                      className="btn btn-visito-primary btn-sm w-max d-flex align-items-center gap-2"
                    >
                      <FormattedMessage id="common.reviewNow" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </>
  );
}
